export default {
  // Page Header
  page_header: {
    title: "Канали",
    description: "Следете ги врските кон апаратите и управувајте со комуникациските канали за Iris Core.",
    metadata: {
      locations: {
        label: "Локации",
        tooltip: "Локации со конфигурирани комуникациски канали",
      },
      instruments: {
        label: "Апарати",
        tooltip: "Апарати поврзани со најмалку еден канал",
      },
      running: {
        label: "Активни",
        tooltip: "Канали стартувани од Iris Core",
      },
      connected: {
        label: "Поврзани",
        tooltip: "Канали со активна TCP врска до апарат",
      },
      disabled: {
        label: "Неактивни",
        tooltip: "Канали исклучени во конфигурацијата",
      },
    },
    action_buttons: {
      add: {
        label: "Додавање канал",
        tooltip: "Додавање комуникациски канал",
      },
      refresh: {
        label: "Освежи",
        tooltip: "Освежување на листата на канали",
      },
    },
  },

  // Content
  channel_card: {
    action_buttons: {
      start: "Стартирање",
      stop: "Запирање",
      console: "Оддалечена работна површина",
      console_description: "Отворање на оддалечена работна сесија за овој канал",
      edit: "Уреди канал",
      edit_description: "Промена на протокол, порт, апарат или активност",
      delete: "Избриши канал",
      delete_description: "Отстранување на овој комуникациски канал",
      more_actions: "Повеќе акции",
      tests: "Тестови",
      tests_description: "Преглед и управување со тестовите на апаратот",
    },
  },
  channels_table: {
    tabs: {
      all: "Канали",
    },
    summary: {
      running: "{count} активни",
      connected: "{count} поврзани",
      disabled: "{count} неактивни",
    },
    columns: {
      channel: "Канал",
      instrument: "Апарат",
      driver: "Драјвер",
      driver_tooltip:
        "Комуникациски протоколен драјвер кој се користи за парсирање на пораките од апаратот. Мора да одговара на реалниот протокол на апаратот.",
      port: "Порт",
      port_tooltip: "TCP портот на кој каналот слуша за дојдовни податоци од апаратот.",
      enabled: "Овозможен",
      enabled_column_tooltip: "Вклучените канали можат да се стартуваат; исклучените не учествуваат во обработката.",
      note: "Белешка",
    },
    collapse_group: "Собери ја групата по локација",
    expand_group: "Прошири ја групата по локација",
    filter_location: "Локација",
    filter_location_all: "Сите локации",
    filter_location_tooltip: "Филтрирај канали по локација",
    filter_location_active_tooltip: "Прикажани канали од: {name}. Кликнете за промена.",
    empty: {
      title: "Нема достапни канали",
      description: "Создајте комуникациски канал за поврзување на апарат со Iris Core.",
    },
  },
  channel_crud: {
    add: "Додај канал",
    add_title: "Додавање канал",
    add_subtitle: "Создавање комуникациска врска до апарат",
    onboarding_title: "Конфигурирање комуникациски канал",
    onboarding_subtitle: "Последен чекор по создавањето на апаратот",
    onboarding_hint:
      "Апаратот е создаден. Сега изберете протокол / драјвер и TCP порт за Iris да може да комуницира со него.",
    edit_title: "Уреди канал",
    view_title: "Детали за каналот",
    delete_title: "Избриши канал",
    delete_message: "Овој канал ќе биде трајно отстранет.",
    delete_running_connected_message:
      "Каналот работи и уредот е активно поврзан. Запирањето ќе ја затвори активната TCP сесија и ќе го отстрани каналот трајно.",
    delete_running_message: "Каналот работи и прифаќа TCP конекции. Ќе биде запрен и трајно отстранет.",
    delete_stopped_connected_message:
      "Каналот е запрен, но уредот сè уште има отворена конекција. Бришењето ќе ја затвори трајно.",
    protocol_hint:
      "Протоколот се избира преку драјверот на апаратот. Каналот поврзува еден апарат со Iris преку драјвер и TCP порт.",
    view_mode_edit_btn: "Уреди",
    view_mode_btn: "Преглед",
    view_subtitle: "Само за преглед — кликнете Уреди за промени",
    edit_mode_confirm_btn: "Режим уредување",
    running_edit_blocked: "Каналот е активен — запрете го пред уредување",
    running_banner: "Каналот е активен. Запрете го пред да правите промени.",
    stop_and_edit: "Запирање и уредување",
    stop_and_delete: "Запирање и бришење",
    stop_and_delete_confirm_title: "Запирање и бришење на канал",
    stop_and_delete_confirm_body:
      "Ова ќе го запре каналот, ќе ги затвори сите активни TCP сесии и ќе го отстрани трајно. Ова дејство не може да се повлече.",
    delete_confirm_title: "Трајно бришење на канал",
    delete_confirm_body: "Каналот ќе биде трајно отстранет и не може да се поврати. Дали сте сигурни?",
    running_blocked_title: "Каналот е стартиран",
    running_blocked_body:
      "Каналот е моментално стартуван и прифаќа TCP конекции. Уредувањето не е дозволено додека каналот е активен — запрете го за да направите промени на конфигурацијата.",
    edit_confirm_title: "Уредување на канал",
    edit_confirm_body:
      "Преминувате во режим на уредување. Можете да ги промените поставките на каналот: име, порт, апарат, протокол / драјвер, активност и белешка.",
    save_confirm_title: "Зачувување промени",
    save_confirm_body:
      "Промените ќе бидат испратени до Iris Core и ќе се прикажат во листата само откако серверот ќе ја потврди промената.",
    unsaved_title: "Незачувани промени",
    unsaved_save_and_close: "Зачувување и продолжување",
    unsaved_discard: "Отфрлување",
    unsaved_stay: "Остани",
    fields: {
      name: "Име на канал",
      name_hint: "Видливо име за оваа комуникациска врска",
      name_placeholder: "на пр. Cobas e801 TCP канал",
      port: "Порт",
      port_hint: "TCP порт што Iris Core го користи за комуникација со апаратот",
      port_placeholder: "на пр. 5001",
      instrument: "Апарат",
      instrument_hint: "Физички апарат со кој се поврзува овој канал",
      instrument_lis_id_label: "LIS ID",
      driver: "Протокол / драјвер",
      driver_hint: "Протокол и модел за конкретниот апарат",
      enabled: "Активен",
      enabled_active: "Вклучен",
      enabled_inactive: "Исклучен",
      enabled_active_hint: "Каналот е активен и прифаќа TCP врски",
      enabled_inactive_hint: "Каналот е деактивиран",
      note: "Белешка",
      note_hint: "Опционална оперативна белешка за овој канал",
      note_placeholder: "на пр. Главен интерфејс на анализаторот, маса 2",
      note_empty: "Без белешка",
    },
    form_sections: {
      basic: "Основни поставки",
      connection: "Врска со апаратот",
      operation: "Состојба и белешка",
    },
    validation: {
      note_too_long: "Белешката е предолга — максимум {max} знаци",
      name_too_long: "Името на каналот е предолго — максимум {max} знаци",
      name_required: "Името на каналот е задолжително",
      name_taken: "Веќе постоји канал со ово име",
      port_required: "Портот е задолжителен",
      port_taken: "Овој порт веќе го користи друг канал",
      instrument_required: "Апаратот е задолжителен",
      driver_required: "Протоколот / драјверот е задолжителен",
    },
    driver_picker_search: "Барај по производител или модел…",
    driver_no_results: "Не се пронајдени драјвери за вашето барање.",
    snackbar_created: "Каналот {name} беше создаден",
    snackbar_updated: "Каналот {name} беше ажуриран",
    snackbar_deleted: "Каналот {name} беше избришан",
    snackbar_save_failed: "Каналот не можеше да се зачува — проверете ги полињата и обидете се повторно",
    snackbar_delete_failed: "Каналот не можеше да се избрише — обидете се повторно",
    snackbar_stop_before_delete_failed: "Каналот {name} не можеше да биде запрен — не беше избришан",
    subtitle_channel: "Канал",
    subtitle_channel_id: "ID на канал",
    subtitle_channel_id_tooltip: "Уникален идентификатор на каналот во системата",
    subtitle_location: "Локација",
    subtitle_location_tooltip: "Локацијата на која припаѓа апаратот — сала, оддел или зграда",
  },
  channel: "канал",
  channels: "канали",
  online: "Онлајн",
  offline: "Офлајн",
  connected: "Поврзан",
  not_connected: "Не е поврзан",
  channel_status: {
    disabled: "Каналот е деактивиран",
    stopped: "Запрен, подготвен за стартување",
    stopped_connected: "Запрен, уредот е сè уште поврзан",
    running_waiting: "Работи, нема TCP врска",
    running_connected: "Работи и е поврзан",
  },
  instrument_name: "Име на апарат",
  driver_id: "ID на драјвер",
  port: "Порт",

  // Empty State
  no_channels_title: "Нема достапни канали",
  no_channels_description: "Моментално нема конфигурирани канали. Ве молиме проверете ја врската или освежете.",
  refresh_channels: "Освежи",
};
